// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  background: rgba(0, 0, 0, 0.9);
  --cms-header-icon-color: #fff;
  --cms-header-text-color: #fff;
}
:host ion-header {
  background-color: transparent !important;
  --cms-header-icon-color: #fff;
  --cms-header-text-color: #fff;
}
:host ion-header ion-toolbar {
  --background: transparent !important;
}
:host ion-header ion-toolbar ion-buttons ion-button,
:host ion-header ion-toolbar ion-buttons .button {
  --cms-header-icon-color: #fff;
  --color: #fff !important;
  color: #fff !important;
  background-color: transparent !important;
}
:host ion-header ion-toolbar ion-buttons ion-button ion-icon,
:host ion-header ion-toolbar ion-buttons ion-button i,
:host ion-header ion-toolbar ion-buttons .button ion-icon,
:host ion-header ion-toolbar ion-buttons .button i {
  color: #fff !important;
}
:host ion-header ion-toolbar ion-buttons .button {
  position: relative;
  padding: 0 5px;
}
:host ion-header ion-toolbar ion-title {
  color: #fff !important;
}
:host ion-content {
  --background: transparent;
  background-color: transparent !important;
}
:host ion-content .swiper-pagination .swiper-pagination-current {
  color: #fff;
}
:host ion-content .gallery-main-image {
  height: 100%;
  --bullet-background: #fff;
  --bullet-background-active: #fff;
}
:host ion-content .gallery-main-image ion-slide {
  display: flex;
  flex-direction: column;
}
:host ion-content .gallery-main-image ion-slide .main-image {
  width: 100%;
  min-height: calc(60vh - 44px);
  max-height: 58vh;
  object-fit: contain;
  object-position: center;
}
:host ion-content .gallery-main-image ion-slide .swiper-zoom-container {
  min-height: calc(60vh - 44px);
  max-height: 58vh;
}
:host ion-content .gallery-main-image ion-slide toolbar-comments-likes {
  width: 100%;
}
:host .gallery-thumbnails {
  display: flex;
  align-items: flex-end;
  background-color: transparent;
}
:host .gallery-thumbnails swiper-container {
  display: block;
  width: 100%;
  height: 100%;
}
:host .gallery-thumbnails swiper-container swiper-slide {
  height: 22vw;
  padding: 10px 0px 10px 10px;
}
:host .gallery-thumbnails swiper-container swiper-slide img {
  object-fit: cover;
  object-position: center;
  width: 100%;
  height: 100%;
}
:host toolbar-comments-likes {
  color: white;
}
:host .is-video .icon-play {
  background-color: white;
  border-radius: 50%;
  height: 50px;
  width: 50px;
  top: calc(50% - 35px);
  padding: 10px 7px 10px 13px;
  left: calc(50% - 35px);
  position: absolute;
  box-shadow: 0px 0px 10px -2px var(--ion-color-dark);
  color: var(--ion-color-dark);
}

:host-context(.plt-desktop) {
  background: rgba(0, 0, 0, 0.8);
  align-items: center;
}
:host-context(.plt-desktop) .gallery-thumbnails swiper-container swiper-slide {
  height: 200px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/image-modal/image-modal.scss"],"names":[],"mappings":"AAAA;EACE,8BAAA;EACA,6BAAA;EACA,6BAAA;AACF;AACE;EACE,wCAAA;EACA,6BAAA;EACA,6BAAA;AACJ;AACI;EACE,oCAAA;AACN;AAEQ;;EAEE,6BAAA;EACA,wBAAA;EACA,sBAAA;EACA,wCAAA;AAAV;AAEU;;;;EAEE,sBAAA;AAEZ;AAEQ;EACE,kBAAA;EACA,cAAA;AAAV;AAIM;EACE,sBAAA;AAFR;AAOE;EACE,yBAAA;EACA,wCAAA;AALJ;AAQM;EACE,WAAA;AANR;AAUI;EACE,YAAA;EACA,yBAAA;EACA,gCAAA;AARN;AASM;EACE,aAAA;EACA,sBAAA;AAPR;AAQQ;EACE,WAAA;EACA,6BAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;AANV;AASQ;EACE,6BAAA;EACA,gBAAA;AAPV;AAUQ;EACE,WAAA;AARV;AAcE;EACE,aAAA;EACA,qBAAA;EACA,6BAAA;AAZJ;AAcI;EACE,cAAA;EACA,WAAA;EACA,YAAA;AAZN;AAaM;EACE,YAAA;EACA,2BAAA;AAXR;AAaQ;EACE,iBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;AAXV;AAiBE;EACE,YAAA;AAfJ;AAmBI;EACE,uBAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,qBAAA;EACA,2BAAA;EACA,sBAAA;EACA,kBAAA;EACA,mDAAA;EACA,4BAAA;AAjBN;;AAqBA;EACE,8BAAA;EACA,mBAAA;AAlBF;AAwBM;EACE,aAAA;AAtBR","sourcesContent":[":host {\n  background: rgba(0, 0, 0, 0.9);\n  --cms-header-icon-color: #fff;\n  --cms-header-text-color: #fff;\n\n  ion-header {\n    background-color: transparent !important;\n    --cms-header-icon-color: #fff;\n    --cms-header-text-color: #fff;\n\n    ion-toolbar {\n      --background: transparent !important;\n\n      ion-buttons {\n        ion-button,\n        .button {\n          --cms-header-icon-color: #fff;\n          --color: #fff !important;\n          color: #fff !important;\n          background-color: transparent !important;\n\n          ion-icon,\n          i {\n            color: #fff !important;\n          }\n        }\n\n        .button {\n          position: relative;\n          padding: 0 5px;\n        }\n      }\n\n      ion-title {\n        color: #fff !important;\n      }\n    }\n  }\n\n  ion-content {\n    --background: transparent;\n    background-color: transparent !important;\n\n    .swiper-pagination {\n      .swiper-pagination-current {\n        color: #fff;\n      }\n    }\n\n    .gallery-main-image {\n      height: 100%;\n      --bullet-background: #fff;\n      --bullet-background-active: #fff;\n      ion-slide {\n        display: flex;\n        flex-direction: column;\n        .main-image {\n          width: 100%;\n          min-height: calc(60vh - 44px);\n          max-height: 58vh;\n          object-fit: contain;\n          object-position: center;\n        }\n\n        .swiper-zoom-container {\n          min-height: calc(60vh - 44px);\n          max-height: 58vh;\n        }\n\n        toolbar-comments-likes {\n          width: 100%;\n        }\n      }\n    }\n  }\n\n  .gallery-thumbnails {\n    display: flex;\n    align-items: flex-end;\n    background-color: transparent;\n\n    swiper-container {\n      display: block;\n      width: 100%;\n      height: 100%;\n      swiper-slide {\n        height: 22vw;\n        padding: 10px 0px 10px 10px;\n\n        img {\n          object-fit: cover;\n          object-position: center;\n          width: 100%;\n          height: 100%;\n        }\n      }\n    }\n  }\n\n  toolbar-comments-likes {\n    color: white;\n  }\n\n  .is-video {\n    .icon-play {\n      background-color: white;\n      border-radius: 50%;\n      height: 50px;\n      width: 50px;\n      top: calc(50% - 35px);\n      padding: 10px 7px 10px 13px;\n      left: calc(50% - 35px);\n      position: absolute;\n      box-shadow: 0px 0px 10px -2px var(--ion-color-dark);\n      color: var(--ion-color-dark);\n    }\n  }\n}\n:host-context(.plt-desktop) {\n  background: rgba(0, 0, 0, 0.8);\n  align-items: center;\n  .gallery-main-image {\n  }\n\n  .gallery-thumbnails {\n    swiper-container {\n      swiper-slide {\n        height: 200px;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
